module.exports = __webpack_public_path__ + "static/grick-screen-image-93db30fd64f7c02e06e05354e9994b76.png";